import { useEffect, useState } from "react";
import { Download, ExternalLink, FileSignature } from "lucide-react";
import api, { API, fmtIDR, fmtDate } from "@/lib_app/api";

/** Read-only list of quotation PDFs auto-attached to a prospect (used in Prospect & Project modals). */
export default function QuotationAttachments({ prospectId, onOpenQuotation }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!prospectId) { setRows([]); return; }
    api.get(`/quotations`, { params: { prospect_id: prospectId } })
      .then((r) => setRows(r.data || []))
      .catch(() => setRows([]));
  }, [prospectId]);

  if (!prospectId || rows.length === 0) return null;

  const openPdf = (id) => {
    const token = localStorage.getItem("sp_token");
    window.open(`${API}/quotations/${id}/pdf?auth=${encodeURIComponent(token || "")}`, "_blank");
  };

  return (
    <div className="space-y-2" data-testid="quotation-attachments">
      <div className="flex items-center gap-2">
        <FileSignature className="w-3.5 h-3.5 text-[#3B4A63]" />
        <span className="text-[10px] uppercase tracking-widest text-[#A0A3A8] font-bold">
          Dokumen Quotation ({rows.length}) · otomatis dari sistem
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {rows.map((q) => (
          <div
            key={q.id}
            onClick={() => openPdf(q.id)}
            data-testid={`quotation-attachment-${q.id}`}
            className="rounded-2xl bg-white border border-[#DCE0E7]/60 p-4 flex items-center gap-3 hover:shadow-md transition cursor-pointer"
          >
            <div className="w-11 h-11 rounded-xl bg-[#FDE7E9] flex items-center justify-center text-[#CE6968] font-bold text-[10px] shrink-0">PDF</div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-[#090808] truncate font-mono">{q.number}</div>
              <div className="text-[11px] text-[#A0A3A8] mt-0.5 truncate">
                {fmtDate(q.date)} · <span className="font-num tabular-nums text-[#3B4A63] font-semibold">{fmtIDR(q.grand_total)}</span>
                {q.ppn_type === "ppn" ? " · PPN 11%" : " · Non-PPN"}
              </div>
            </div>
            <button
              onClick={(e) => { e.stopPropagation(); openPdf(q.id); }}
              data-testid={`quotation-attachment-download-${q.id}`}
              title="Unduh PDF"
              className="w-8 h-8 rounded-full hover:bg-[#F4F5F7] text-[#3B4A63] flex items-center justify-center shrink-0"
            >
              <Download className="w-3.5 h-3.5" />
            </button>
            {onOpenQuotation && (
              <button
                onClick={(e) => { e.stopPropagation(); onOpenQuotation(q.id); }}
                data-testid={`quotation-attachment-open-${q.id}`}
                title="Buka quotation"
                className="w-8 h-8 rounded-full hover:bg-[#E5EEFA] text-[#3B4A63] flex items-center justify-center shrink-0"
              >
                <ExternalLink className="w-3.5 h-3.5" />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
